import { AkaHealthProductIntroFormValues } from "./akaHealthProductIntroInterfaces";

export const AKA_HEALTH_PRODUCT_INTRO_INITIAL_FORM_VALUES: Partial<AkaHealthProductIntroFormValues> =
  {
    isMemberOfNordicSocialSecurity: undefined,
    isCoInsured: undefined,
  };
